<template>
  <div class="edc-codes-container">
    <div
      v-for="(none, index) in v.$model"
      :key="index"
      class="edc-code-container"
    >
      <v-row class="edc-code-item">
        <v-col cols="12" align="end">
          <div class="edc-code-item-header">
            <span class="edc-code-item-header-title">
              EDC
              <template v-if="v.$model[index].edc_terminal">
                : {{ v.$model[index].edc_terminal }}
              </template>
            </span>
            <span
              v-if="v.$model[index].edc_credit_card_no"
              class="credit-card-no"
            >
              <v-icon size="18" color="primary">
                mdi-credit-card-outline
              </v-icon>
              ****-{{ v.$model[index].edc_credit_card_no }}
            </span>
          </div>
        </v-col>

        <!-- card_id -->
        <v-col cols="12">
          <v-autocomplete
            v-model="v.$model[index].card_id"
            :hide-details="!v.$each[index].card_id.$error"
            :error="v.$each[index].card_id.$error"
            :error-messages="handleErrorMessage(index, 'card_id')"
            :items="cardTypesByPayAtStoreChoice"
            color="primary"
            item-text="card_name"
            item-value="card_id"
            ref="card_id"
            data-pptr="card_id"
            label="ประเภทบัตร"
            placeholder="เลือกประเภทบัตร"
            background-color="white"
            outlined
          />
        </v-col>

        <!-- edc_terminal *only payment_type == "edc_credit_card | edc_qr" -->
        <v-col cols="12">
          <v-autocomplete
            v-model="v.$model[index].edc_terminal"
            :hide-details="!v.$each[index].edc_terminal.$error"
            :error="v.$each[index].edc_terminal.$error"
            :error-messages="
              handleErrorMessage(index, 'edc_terminal')
            "
            :items="edcCode"
            color="primary"
            :loading="isEdcLoading"
            data-pptr="edc_terminal"
            item-text="edc_name"
            item-value="tid"
            label="EDC Code"
            placeholder="เลือก EDC Code"
            outlined
            background-color="white"
          ></v-autocomplete>
        </v-col>

        <v-col :cols="isEdcCreditCard ? 8 : 12">
          <v-text-field
            v-model="v.$model[index].approval_code"
            :hide-details="!v.$each[index].approval_code.$error"
            :error="v.$each[index].approval_code.$error"
            :error-messages="
              handleErrorMessage(index, 'approval_code')
            "
            color="primary"
            data-pptr="approval_code"
            label="เลขที่ใบเสร็จรับเงิน (Approval Code)"
            outlined
            background-color="white"
            maxlength="20"
            placeholder="กรอกเลขที่ใบเสร็จรับเงิน (Approval Code)"
          ></v-text-field>
        </v-col>

        <!-- edc_credit_card_no *only payment_type == "edc_credit_card" -->
        <v-col v-if="isEdcCreditCard" cols="4">
          <v-text-field
            v-model="v.$model[index].edc_credit_card_no"
            :hide-details="!v.$each[index].edc_credit_card_no.$error"
            :error="v.$each[index].edc_credit_card_no.$error"
            :error-messages="
              handleErrorMessage(index, 'edc_credit_card_no')
            "
            color="primary"
            data-pptr="edc_credit_card_no"
            label="เลขบัตร 4 ตัวท้าย"
            outlined
            background-color="white"
            placeholder="• • • •"
            oninput="this.value=this.value.slice(0,4).replace(/[^\d]+/g, '')"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="edc-paid-amount">
          <v-text-field
            v-model="v.$model[index].edc_paid_amount"
            :error="
              v.$each[index].edc_paid_amount.$error ||
                errorEdcPaidAmount
            "
            :error-messages="
              handleErrorMessage(index, 'edc_paid_amount')
            "
            :hint="handleHintMessage()"
            color="primary"
            persistent-hint
            data-pptr="edc_paid_amount"
            label="จำนวนเงินที่ชำระ"
            outlined
            background-color="white"
            placeholder="กรอกจำนวนเงินที่ชำระ"
            oninput="this.value=this.value.replace(/[^\d]+/, '')"
            clearable
          ></v-text-field>

          <div class="d-flex">
            <v-chip
              v-if="
                !v.$model[index].edc_paid_amount &&
                  remainingPaidAmount > 0
              "
              small
              outlined
              class="px-2"
              color="primary"
              @click.stop="addRemaining(index, remainingPaidAmount)"
            >
              <v-icon size="12px" class="mr-1">
                mdi-plus
              </v-icon>
              {{ remainingPaidAmount | currency }}
            </v-chip>
          </div>
        </v-col>

        <v-col cols="12" align="end" class="pt-0">
          <v-btn
            :disabled="v.$model.length <= 1"
            class="btn-remove"
            depressed
            small
            @click.stop="dialogRemove = true"
          >
            <v-icon>
              mdi-delete
            </v-icon>
            ลบ
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div v-if="v.$model.length < 3" class="edc-code">
      <v-btn
        depressed
        color="primary"
        :disabled="v.$model.length >= 3"
        @click="$emit('add-edc-code')"
      >
        <v-icon size="18px" class="mr-2">
          mdi-plus-circle-outline
        </v-icon>
        เพิ่ม EDC Code
      </v-btn>
    </div>

    <v-dialog v-model="dialogRemove" max-width="290">
      <v-card>
        <v-card-text class="py-4">
          <v-row>
            <v-col cols="12" class="text-center">
              <div class="header-modal-title">
                ยืนยันลบ EDC Code?
              </div>
            </v-col>
            <v-col cols="12" class="text-center">
              หลังจากลบแล้วจะไม่สามารถกู้คืนได้
              ต้องทำการเพิ่มและกรอกข้อมูลใหม่อีกครั้ง
            </v-col>

            <v-col cols="12">
              <v-btn
                :loading="isLoading"
                block
                depressed
                large
                class="font-bold"
                color="#FF4252"
                @click="
                  $emit('remove-edc-code', index),
                    (dialogRemove = false)
                "
              >
                ยืนยัน
              </v-btn>
            </v-col>

            <v-col cols="12">
              <v-btn
                block
                depressed
                link
                large
                @click="dialogRemove = false"
              >
                ยกเลิก
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ConfirmPaymentEdcCodes',

  props: {
    value: {
      type: Array,
      default: () => [],
      required: true,
    },
    v: {
      type: Object,
      default: () => ({}),
    },
    isError: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: '',
    },
    isEdcCreditCard: {
      type: Boolean,
      default: false,
    },
    isEdcQr: {
      type: Boolean,
      default: false,
    },
    payAtStoreChoiceId: {
      type: String,
      default: '',
    },
    paidAmount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // Import

      dialogRemove: false,

      form: {
        voucher_code: [],
      },
    }
  },

  computed: {
    ...mapState({
      edcCode: state => state.paymentType.edc.code || [],
    }),

    cardTypesByPayAtStoreChoice() {
      return this.$store.getters[
        'paymentType/getCardTypesByPayAtStoreChoiceId'
      ](this.payAtStoreChoiceId)
    },

    errorEdcPaidAmount() {
      return this.summaryPaidAmount !== this.paidAmount
    },

    summaryPaidAmount() {
      return this.v.$model.reduce(
        (sum, payment) => sum + Number(payment.edc_paid_amount),
        0,
      )
    },

    remainingPaidAmount() {
      return this.paidAmount - this.summaryPaidAmount
    },
  },

  async mounted() {},

  methods: {
    async clearVoucher() {},

    handleErrorMessage(index, field) {
      if (field === 'edc_paid_amount' && this.errorEdcPaidAmount) {
        return this.handleHintMessage()
      }

      return this.v.$each[index][field].$error ? ' กรุณาระบุ' : ''
    },

    handleHintMessage() {
      return this.remainingPaidAmount < 0
        ? `ยอดรวมทั้งหมดที่ระบุ ${this.$options.filters.currency(
            this.summaryPaidAmount,
          )} เกินจากยอดที่ต้องชำระ ${this.$options.filters.currency(
            Math.abs(this.remainingPaidAmount),
          )} บาท`
        : this.remainingPaidAmount != 0
        ? `ยอดที่ต้องชำระเหลืออีก ${this.$options.filters.currency(
            this.remainingPaidAmount,
          )} บาท`
        : ''
    },

    addRemaining(index, value) {
      this.v.$model[index].edc_paid_amount = String(value)
    },
  },
}
</script>

<style lang="stylus" scoped>
.edc-codes-container
  display flex
  flex-direction column
  gap 16px
  // border-radius: 8px
  // padding 16px

.edc-code-container
  border-radius: 8px
  background-color: #f5f5f7
  display flex
  flex-direction column
  align-items center
  padding 8px 16px
  gap 16px

.edc-code-item
  width: stretch;

.edc-code
  width 100%
  display flex
  flex-direction row
  flex-wrap nowrap
  align-items center
  justify-content flex-end
  gap 16px

form
  display flex
  flex-direction row
  align-items center

.message
  width 100%
  flex-basis 100%
  color red
  font-size 14px

.message-success
    width 100%

::v-deep .v-text-field--enclosed .v-input__prepend-inner {
    margin: auto 0
}

::v-deep .v-btn.btn-remove {
    padding: 0 8px !important
    min-width: 50px !important
    color: rgba(0,0,0, 0.45) !important
}

.header-modal-title
  font-size: 24px
  font-weight: bold
  font-family: $font-family-base !important
  align-self: center

.edc-code-item-header
  display: flex
  justify-content: space-between
  align-items: center
  width: stretch
  font-weight: bold

.edc-code-item-header-title
    text-align: left

.credit-card-no
    padding: 0 8px;
    padding-size: 'fit-content';
    background-color: white;
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    gap: 4px;

.edc-paid-amount{
	::v-deep(.v-text-field__details){
		padding 0 !important
		.v-messages__message {
			line-height 1.5 !important
		}
	}
}
</style>
